import { css } from 'linaria';

export const calculatorPanelSection = css`
  && {
    padding: 24px 0;
    background-color: var(--secondary-green-light);

    @media (--only-mobile) {
      padding: 40px 0;
    }
  }
`;

export const calculatorPanelWrapper = css`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const calculatorPanelIcon = css`
  display: block;
  margin-right: 24px;

  @media (--only-tablet) {
    margin-right: 16px;
  }

  @media (--only-mobile) {
    position: absolute;
    top: 0;
    left: 0;
    width: 74px;
    height: auto;
    margin-right: 0;
  }
`;

export const calculatorPanelContent = css`
  @media (--from-tablet) {
    flex-grow: 1;
  }
`;

export const calculatorPanelTitle = css`
  && {
    margin-bottom: 8px;

    @media (--only-mobile) {
      width: 288px;
      padding-left: 74px;
      margin-bottom: 16px;
    }
  }
`;

export const calculatorPanelText = css`
  && {
    line-height: 28px;

    @media (--only-desktop) {
      width: 363px;
    }

    @media (--only-tablet) {
      width: 345px;
    }

    @media (--only-mobile) {
      margin-bottom: 24px;
      line-height: 24px;
    }
  }
`;

export const calculatorPanelButton = css`
  @media (--only-mobile) {
    width: 100%;
  }
`;
